'use strict'
var mapper = require('./mapper')
var compileRoute = require('./compileRoute')

module.exports = function urlMapper (options) {
  return mapper(compileRoute, options)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/url-mapper/index.js
// module id = 782
// module chunks = 1